import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  return (
    <div style={{ background: 'var(--color-bg)' }}>
      <Navbar />

      <div style={{ paddingTop: 80 }}>
        <div className="contact-layout" style={{ display: 'grid', gridTemplateColumns: '1fr 2.7fr', minHeight: '80vh' }}>

          {/* Left — info */}
          <div className="contact-info-panel" style={{ padding: '48px 32px', background: 'var(--color-surface-alt)' }}>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '24px', fontWeight: 400, color: 'var(--color-text)', marginBottom: 24, lineHeight: 1.3 }}>
              Let's Create Something Beautiful
            </h1>
           <img
              src="/assets/instagram-avatar.jpg"
              alt="Bhagyashree Dhavalshankh"
              style={{ width: 122, height: 122, borderRadius: '50%', objectFit: 'cover',marginLeft:100, marginBottom: 20, display: 'block' }}
            />
            <p style={{ fontSize: 14, color: 'var(--color-muted)', marginBottom: 10, fontFamily: 'var(--font-body)' }}>📧 framesbybhagya@gmail.com</p>
            <p style={{ fontSize: 14, color: 'var(--color-muted)', marginBottom: 10, fontFamily: 'var(--font-body)' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: 6 }}>
                <defs>
                  <linearGradient id="instagramGradientContact" x1="0%" y1="100%" x2="100%" y2="0%">
                    <stop offset="0%" style={{ stopColor: '#FD5949', stopOpacity: 1 }} />
                    <stop offset="50%" style={{ stopColor: '#D6249F', stopOpacity: 1 }} />
                    <stop offset="100%" style={{ stopColor: '#285AEB', stopOpacity: 1 }} />
                  </linearGradient>
                </defs>
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke="url(#instagramGradientContact)"></rect>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke="url(#instagramGradientContact)"></path>
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="url(#instagramGradientContact)"></line>
              </svg>
              @framesbybhagya
            </p>
            <p style={{ fontSize: 14, color: 'var(--color-muted)', marginBottom: 10, fontFamily: 'var(--font-body)' }}>📍 Pune, Maharashtra</p>
            <p style={{ fontFamily: 'var(--font-display)', fontSize: 14, fontStyle: 'italic', color: 'var(--color-text)', marginTop: 24, lineHeight: 1.5 }}>
              "I'd love to capture your story.Let's talk about your vision."
            </p>
          </div>

          {/* Right — form */}
          <div className="contact-form-panel" style={{ padding: '48px 40px', background: 'var(--color-surface)' }}>
            <ContactForm />
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
}